import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import TransferList from './TransactionList';

const Transfer = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title='Listado de Transacciones' pageTitle='Transacciones' />
                <TransferList />
            </div>
        </React.Fragment>
    )
}

export default Transfer;